import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
} from '@angular/material/snack-bar';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-info-snackbar',
  imports: [
    MatSnackBarLabel,
    MatSnackBarAction,
    MatSnackBarActions,
    TranslatePipe,
    MatButton,
  ],
  templateUrl: './info-snackbar.component.html',
  styleUrl: './info-snackbar.component.scss',
})
export class InfoSnackbarComponent {
  text = '';
  close;
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { text: string; close: () => void },
  ) {
    this.text = data.text;
    this.close = data.close;
  }
}
